import React from 'react';
import BookingContextCard from './BookingContextCard';

/**
 * The order context behind a document, one card per booking.
 *
 * Shared by everywhere an invoice can be opened up — the invoices list, the
 * final-Számla queue and the document details modal — so "what was sold" reads
 * identically wherever an agent expands it.
 */
function BookingContextList({ bookings = [], className = '' }) {
  if (bookings.length === 0) return null;
  return (
    <div className={`d-flex flex-column gap-2 ${className}`}>
      {bookings.map((b) => (
        <BookingContextCard key={b.booking_id} booking={b} />
      ))}
    </div>
  );
}

export default BookingContextList;
